import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import imageLoader from '../../Assets/imageLoader.svg';
import './loader.scss';
interface PostCardLoadingProps {
    index?: number;
}

const PostCardLoading: FC<PostCardLoadingProps> = ({ index }) => {
    return (
        <div className='postCard__loading' style={{ animationDuration: index ? `${500 + 50 * index}ms` : '' }}>
            <div className='card sobrusPosts__card'>
                <ContentLoader
                    speed={2}
                    width={476}
                    height={66}
                    backgroundColor='rgba(0,0,0, 0.20)'
                    foregroundColor='rgba(0,0,0, 0.10)'
                    // {...props}
                >
                    <rect x='16' y='0' rx='6' ry='6' width='56' height='56' />
                    <rect x='88' y='8' rx='3' ry='3' width='88' height='6' />
                    <rect x='88' y='26' rx='3' ry='3' width='52' height='6' />
                </ContentLoader>
                <div className='img-container'>
                    <img className='img' src={imageLoader} alt='' />
                </div>
                <ContentLoader
                    speed={2}
                    width={476}
                    height={100}
                    backgroundColor='rgba(0,0,0, 0.20)'
                    foregroundColor='rgba(0,0,0, 0.10)'
                    // {...props}
                >
                    <rect x='16' y='46' rx='3' ry='3' width='410' height='6' />
                    <rect x='16' y='62' rx='3' ry='3' width='380' height='6' />
                    <rect x='16' y='78' rx='3' ry='3' width='178' height='6' />
                </ContentLoader>
            </div>
        </div>
    );
};

export const PostsCardLoading: FC = () => {
    return (
        <>
            {[1, 2, 3].map((_, index) => (
                <PostCardLoading key={String('PostsCardLoading' + index)} index={index + 1} />
            ))}
        </>
    );
};

export const InpuLoader = () => {
    return (
        <div className='ReactPost__loader'>
            <span className='loader__element'></span>
            <span className='loader__element'></span>
            <span className='loader__element'></span>
        </div>
    );
};
